<!-- PORTAIL vers TIPI -->

<template>
  <div class="container">

    <section class="spread">
      <NetworkAlert :title="'Redirection en cours'">
        <p>
          Une redirection est en cours.
          <br>S'il ne se passe rien, cliquez sur le lien suivant :
        </p>
        <div class="buttons">
          <a :href="url">{{ url }}</a>
        </div>
      </NetworkAlert>
    </section>

  </div>
</template>

<script>
import NetworkAlert from '@/components/NetworkAlert.vue'

export default {
  components: {
    NetworkAlert
  },
  data () {
    return {
      url: null
    }
  },
  mounted () {
    if (this.$route.query.url) {
      this.url = this.$route.query.url
      this.redirectToURL()
    } else {
      this.redirectToHome()
    }
  },
  methods: {
    redirectToURL () {
      document.location.href = this.url
    },
    redirectToHome () {
      if (this.$route.params.tenantCode) {
        this.$router.push('/' + this.$route.params.tenantCode)
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
a {
  background: transparent;
  color: gray;
  font-size: 1.2rem;
  color: var(--primary-dark);
}

a:hover {
  box-shadow: none;
  color: var(--primary-light);
}

/* IE10+ CSS styles */
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  a {
    color: #1d3f5f;
  }

  a:hover {
    color: #1d3f5f;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Redirect.vue